import{Node_Type as e}from"ricos-types";const i={alignment:`${e.FILE}.alignment`,size:`${e.FILE}.size`};export{i as FILE_BUTTONS};
//# sourceMappingURL=consts.js.map
